import React from 'react'
import Footer from './Footer'
import Navbar from './Navbar'



const Contact = () => {
  return (
    <>
    <Navbar/>
    <section className='contact-main'>
    <form className='forms'>
      <h3>CONTACT US </h3>
  <div class="form-group">
    <label for="exampleInputEmail1">Email address</label>
    <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter email"/>
    <small id="emailHelp" class="form-text text-muted">We'll never share your email with anyone else.</small>
  </div>
  <div class="form-group">
    <label for="exampleInputPassword1">Password</label>
    <input type="password" class="form-control" id="exampleInputPassword1" placeholder="Password"/>
  </div>
  
  <button type="submit"onClick={()=>alert("data submitted")} class="btn btn-primary">Submit</button>
</form>
       
    </section>
    <Footer/>
    </>
    
  )
}

export default Contact